import React, { useState,useEffect } from 'react'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import useBffFlumeterMap from '../../hooks/useBffFlumeterMap'

import ErrorMessage from '../../components/Layout/ErrorMessage'
import Timeline from '../../components/Timeline'
import Map from '../../components/Map'
import EmptyMap from '../../components/Map/emptyMap'
import MapOptions from '../../components/MapOptions'
import toolTipFormatter from './toolTipFormatter'
import colorRanges from './colorAxisFluIndex'
import regionDisplayOptions from './regionDisplayOptions'
import dataDisplayOptions from './dataDisplayOptions'
import MapLegend from './cdcMapLegend8LevelHorizontal'
import StateStats from './StateStats'
import CbsaStats from './CbsaStats'
import DisplayDateFluNew from '../../components/DisplayDateFlu/DisplayDateFluNew'
import styles from './FluMeter.module.scss'

const FluMap = () => {
  const entity = 'flumeter'
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  //+ getEpiWeek(displayDateUnformatted)
  const [getStateJsonFile, setStateJsonFile] = useState();
    const [getMapStates, setMapStates] = useState()
    const [metros, setMetros] = useState()
    const [activeCbsa, setActiveCbsa] = useState()
  const [cbsaJsonFile, setCbsaJsonFile] = useState();
  const slotString = 'Week'

  const { dataStartDate, dataEndDate, mapOptions, regionSelected ,setDisplayDate} =
    useGeoState()

    useEffect(() => {
      let url = `${window.location.origin}/flu/usStatesAll.json`
      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          // console.log(data)
          setStateJsonFile(data);
        })
        .catch(function (err) {
          console.log(err, " error file load usStatesAll ");
        });
    }, [1]);

    
    
  useEffect(() => {
    let url = `${window.location.origin}/flu/cb_2018_us_cbsa_20m_wkid102004.json`
    fetch(url)
      .then(function (res) {       
        return res.json();
      })
      .then(function (data) {
       // console.log(data)
       setCbsaJsonFile(data);
      })
      .catch(function (err) {
        console.log(err, " error file load cb_2018_us_cbsa_20m_wkid102004 ");
      });
  }, [1]);
  const { data: statesData, error: stateDataError } = useBffFlumeterMap(
    dataStartDate,
    dataEndDate,
    'state'
  )
  useEffect(() => {
      if (statesData !== null && statesData !== undefined) {
          // var datacount= Object.keys(statesData).length-2        
          // setDisplayDate(Object.keys(statesData)[datacount])
          setMapStates(statesData)
        
      }
    }, [statesData])
  const { data: cbsasData, error: cbsasDataError } = useBffFlumeterMap(
    dataStartDate,
    dataEndDate,
    'msa',
    
  )
useEffect(() => {
      if (cbsasData !== null && cbsasData !== undefined) {
              
          setMetros(cbsasData)
        
      }
    }, [cbsasData])
  const { data: activeCbsasData, error: activeCbsasDataError } = useBffFlumeterMap(
    dataStartDate,
    dataEndDate,
    'activecbsa',
    
  )
useEffect(() => {
      if (activeCbsasData !== null && activeCbsasData !== undefined) {
              
          setActiveCbsa(activeCbsasData)
      
      }
    }, [activeCbsasData])
  if (stateDataError || cbsasDataError || activeCbsasDataError) {
    return <ErrorMessage />
  }

  return getMapStates!==undefined && metros!==undefined && activeCbsa!==undefined ? (
    <>
      <div className={styles.container}>
        <div className={styles.map}>
          <div style={{display:'flex'}}>
            <div style={{width:'60%'}}>
               <DisplayDateFluNew
                            statesData={getMapStates}
                            showWeek={true}
                            latestPositionString={latestPositionString}
                            slotString={slotString}
                            slotTimeInSeconds={slotTimeInSeconds}
                            diseaseType={'flu'}
                          /></div>
             <div style={{width:'40%',marginTop:'-20px'}}>
               <MapOptions
          regionDisplayOptions={regionDisplayOptions}
          dataDisplayOptions={dataDisplayOptions}
          activeCbsa={activeCbsa} 
          entity={'flu'}
          datatype={'flumeter'}
          
        /></div>
             
       
          </div>
       
       
          {/* <div className={styles.legend}>
          
          <MapLegend  />
        </div> */}
        <div className={styles.legendDiv}>
                        <MapLegend />
                        </div>
          {regionSelected === 'state' && getStateJsonFile && (
            <Map
              colorRanges={colorRanges}
              showStateLabels={true}
              toolTipFormatter={toolTipFormatter}
              activeCbsasData={null}
              statesData={getMapStates}
              cbsaData={null}
              mapOptions={mapOptions}
              mapHeight={'300px'}
              dynamicMapTitle={false}
              mapType="rsvmap"
              mapDataType={0}
              zoomLocation={'US'}
              stateJson={getStateJsonFile}
              enableButtons={true}
            />
          )}
          {regionSelected === 'msa' && getStateJsonFile && cbsaJsonFile &&  (
            <>
            
            
            <Map
              colorRanges={colorRanges}
              showStateLabels={true}
              toolTipFormatter={toolTipFormatter}
              activeCbsasData={activeCbsa}
              statesData={getMapStates}
              cbsaData={metros}
              mapOptions={mapOptions}
              mapHeight={'300px'}
              dynamicMapTitle={false}
              mapType="rsvmapmsa"
               mapDataType={1}
               zoomLocation={'US'}
              stateJson={getStateJsonFile}
              JsonData={cbsaJsonFile}
              enableButtons={true}
            />
            </>
          )}
        
        </div>
        <div className={styles.rightPanel}>
          {regionSelected === 'state' && (
            <StateStats stateData={statesData} mapOptions={mapOptions} />
           
          )}

          {regionSelected === 'msa' && (
            <CbsaStats cbsaData={cbsasData} mapOptions={mapOptions} />
          )}
        </div>
      </div>
      <Timeline
        statesData={statesData}
        latestPositionString={latestPositionString}
        slotString={slotString}
        slotTimeInSeconds={slotTimeInSeconds}
        markCounts={3}
      />
    </>
  ) : (
    <EmptyMap mapHeight={'365px'} stateJson={getStateJsonFile} />
  )
}

export default FluMap
